import { smartpayHttp } from './http';

export const getPaymentMethods = () => {
  return smartpayHttp.get('/payments/providers');
};

export const initializePayment = (data) => {
  return smartpayHttp.post(`/payments/${data.provider ?? 'oppwa'}/init`, data);
};

export const verifyPayment = (data) => {
  return smartpayHttp.get(`/payments/${data.provider ?? 'oppwa'}/callback`, {
    params: data,
  });
};
